export const en = {
    person_header: 'User',
    company_header: 'Company',
    group_header: 'Travel policy / group',
    suggest_placeholder: 'Start typing name or email',
    no_group: 'No',
    not_found__description: 'Try searching differently or add a new user',
    not_found__title: 'Could not find user',
};
